import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { resolvePageTitle } from "config/breadcrumbRoutes";
import * as S from "./style";

function PageTitle() {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const title = resolvePageTitle(pathname, t);

  if (!title) {
    return null;
  }

  return (
    <S.Wrapper>
      <S.Title>{title}</S.Title>
      <S.Divider />
    </S.Wrapper>
  );
}

export default PageTitle;
